module.exports = __webpack_public_path__ + "img/recommend.4082fdf.png";